import { Component, EventEmitter, OnInit, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router, ActivatedRoute, RouterModule } from "@angular/router";
import { IKeyContact } from "../../../interfaces/ikeycontact";
import { EmitterService } from "../../../services/emitter.service";
import { IButton } from "../../../interfaces/ibuttons";

@Component({
    selector: "keycontacts",
    templateUrl: "./keycontacts.component.html",
    standalone: true,
    imports: [CommonModule, RouterModule]
})
export class KeyContactsComponent implements OnInit {

    @Input() keyContacts: IKeyContact[];
    hideDisableUpdates: boolean = true;
    headerButtons: IButton[];

    ngOnInit(): void {
      //  this.keyContacts = this.activatedRoute.snapshot.data["keyContacts"];
    }

    constructor(private router: Router, private activatedRoute: ActivatedRoute) {
        let emitter: EventEmitter<any> = EmitterService.get("Create key contact");
        let button: IButton = { label: "Create key contact", btnClass: "fa fa-plus ml-2", btnClicked: emitter, disable: false };
        this.headerButtons = [button];
        this.headerButtons = [button];
        emitter.subscribe(() => {
            this.router.navigate(["/keycontacts/keycontact"]);
        });
    }

    editClicked(contact: IKeyContact): void {
        this.router.navigate([`/keycontacts/keycontact/${contact.id}`]);
    }

    add(): void {
        this.router.navigate([`/keycontacts/keycontact`]);
    }
}
